import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableWooCommerceCheckoutRates = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableWooCommerceCheckoutRates);
};
